import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { doorSensorAwsApi } from '../common/ApiCall'
import moment from 'moment'
import Loading from '../common/Loading'
import { findDatesBetween } from '../redux/action/dailyUnit'

function DoorSensorTable({data,selectedDate,selectedEndDate}) {
  const [error,setError] = useState('')
  let [openSessions,setOpenSessions] = useState([])
  let [loading,setLoading] = useState(false)
  const getDoorSessions = async()=>{
    setLoading(true)
    setError('')
    let dates = findDatesBetween(selectedDate, selectedEndDate);
    let openSessions = []
    for(let date of dates){
   await doorSensorAwsApi(data?.deviceId,date).then(res=>{
        if(res?.openSessions?.length>0){
            openSessions=[...openSessions,...res?.openSessions]
        }   
    })
    }
    if(openSessions?.length>0){
        setOpenSessions(openSessions)
    }else{
        setError('No data found')
    }
    setLoading(false)
  }
  useEffect(()=>{
    getDoorSessions()
  },[data,selectedDate,selectedEndDate])
  function formatDuration(ms) {
  const totalSeconds = Math.floor(ms / 1000);

  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}
  return (
    <div className='mt-4'>
      { loading && <Loading/>}
      <Table>
        <thead>
            <tr>
                <th>Open Since</th>
                <th>Close Since</th>
                <th>Duration</th>
            </tr>
        </thead>
        <tbody>
            {  
                openSessions?.map((session, index)=>{
                    return(
                        <tr key={index}>
                            <td>{moment(session?.startTime).format('DD MMM YYYY, LT')}</td>
                            <td>{moment(session?.endTime).format('DD MMM YYYY, LT')}</td>
                             <td>{formatDuration(session?.endTime-session?.startTime)}</td>
                        </tr>
                    )
                })
            }
            {error && <tr><td colSpan={3}>{error}</td></tr>}
        </tbody>
      </Table>
    </div>
  )
}

export default DoorSensorTable
